// @flow
import React from 'react'

// core
import moment from '../../Moment'

// error types
import { ERROR_TYPES } from '../../Redux/GeneralRedux'

// types
import type { AllErrorType } from '../../Types/ErrorTypes'
import VariablesDebugBlock from './VariablesDebugBlock'

type ShowDebugErrorProps = {
  active?: boolean,
  error: AllErrorType,
}

export default class ShowDebugError extends React.Component<ShowDebugErrorProps> {
  static defaultProps = {
    active: false,
  }

  render = () => {
    if (!this.props.active) {
      return null
    }

    let classColor = 'bg-warning'
    if (ERROR_TYPES.CRITICAL === this.props.error.type) {
      classColor = 'bg-danger'
    } else if (ERROR_TYPES.INFO === this.props.error.type) {
      classColor = 'bg-info'
    }

    const title = `${moment(this.props.error.time).format('YYYY-MM-DD HH:mm:ss')} - ${this.props.error.action}`

    return (
      <VariablesDebugBlock
        active={this.props.active}
        blacklist={['config']}
        className={`mt-3 text-white ${classColor}`}
        collapseBody
        collapseObjects
        title={title}
        variables={{ error: this.props.error.error.toString() }}
      />
    )
  }
}
